exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){.filter-group__filters--bordered3 :nth-child(n){max-width:33.33%}.filter-group__filters--bordered4 :nth-child(n){max-width:24.99%}.filter-group__filters--bordered5 :nth-child(n){max-width:19.99%}.filter-group__filters--colors-white button:last-child{max-width:40%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/assets/css/ie-fixes.css
// module id = 897
// module chunks = 2